/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A selectable option for a custom auth input whose fieldType is "select".
 * @export
 * @interface CustomAuthInputOption
 */
export interface CustomAuthInputOption {
    /**
     * The value stored when this option is selected.
     * @type {string}
     * @memberof CustomAuthInputOption
     */
    value: string;
    /**
     * The human-readable label shown for this option.
     * @type {string}
     * @memberof CustomAuthInputOption
     */
    label: string;
}

/**
 * Check if a given object implements the CustomAuthInputOption interface.
 */
export function instanceOfCustomAuthInputOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function CustomAuthInputOptionFromJSON(json: any): CustomAuthInputOption {
    return CustomAuthInputOptionFromJSONTyped(json, false);
}

export function CustomAuthInputOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAuthInputOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
    };
}

export function CustomAuthInputOptionToJSON(value?: CustomAuthInputOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'label': value.label,
    };
}

